import React from "react";
import { RotaButton, colors, RotaInput } from "@teamrota/rota-design";

import {
  StyledWrapButton,
  StyledButtonWrapper,
  StyledConfirmWrapper,
  StyledWrapConfirmation
} from "../styles";

const BottomModal = ({
  handleCancel,
  handleAdd,
  isConfirmed,
  memberName,
  mustConfirm,
  onChangeInput,
  disableOverride
}) => (
  <StyledButtonWrapper>
    {mustConfirm && (
      <StyledConfirmWrapper>
        <StyledWrapConfirmation>
          Confirm you understand this warning by typing the member's name below
        </StyledWrapConfirmation>
        <RotaInput
          isLabelTop
          placeholder={memberName}
          onChange={e => onChangeInput(e)}
        />
      </StyledConfirmWrapper>
    )}
    <StyledWrapButton>
      <RotaButton onClick={handleCancel} variant="secondary">
        Cancel
      </RotaButton>

      {!disableOverride && (
        <RotaButton
          onClick={handleAdd}
          color={colors.red}
          disabled={!isConfirmed}
        >
          Add member
        </RotaButton>
      )}
    </StyledWrapButton>
  </StyledButtonWrapper>
);

export default BottomModal;
